export default __webpack_public_path__ + "static/media/nInvest.86a2d138.svg";